import { Box } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import RoundedButton from '@components/RoundedButton';

import { useParameter } from '@hooks/useParameter';

import type { ParameterValue } from '@models/reference-range';

const messages = defineMessages({
  reset: {
    id: 'insights.parameter.delete.resetToDefault',
    defaultMessage: 'Reset to Default',
  },
  title: {
    id: 'insights.parameter.delete.title',
    defaultMessage: 'Delete Custom Reference Range',
  },
  description: {
    id: 'insights.parameter.delete.description',
    title:
      "Deleting a patient's custom reference range resets it back to the default.",
  },
});

interface FooterProps {
  parameters: ParameterValue[];
}

export default function Footer({ parameters }: FooterProps) {
  const { formatMessage } = useIntl();
  const { handleResetToDefault, loading } = useParameter();

  // Check if some parameters are custom (has vitall_patient_id)
  const isDisabled = !parameters.some((c) => c.vitall_patient_id) || loading;

  const handleConfirm = async () => {
    if (isDisabled) {
      return;
    }
    await handleResetToDefault(parameters);
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <ConfirmationDialog
        onConfirm={handleConfirm}
        title={`${formatMessage(messages.title)}?`}
        content={formatMessage(messages.description)}
      >
        {({ handleOpen }) => (
          <RoundedButton
            autoSize
            disabled={isDisabled}
            onClick={handleOpen}
            variant="white"
          >
            {formatMessage(messages.reset)}
          </RoundedButton>
        )}
      </ConfirmationDialog>
      {/* TODO: Add 'Set Alert' checkbox below */}
    </Box>
  );
}
